// Estado vazio do grafo, portado de graph.js:125-145.
//
// Vazio tem três causas diferentes e cada uma pede outra ação. Mandar "eng
// reprocess" quando falta memória humana é diagnóstico errado: reprocessar de
// novo não escreve nota nenhuma.
import type { GrafoBruto, Modo } from './nucleo';

interface Props {
  grafo: GrafoBruto | null;
  codigo: GrafoBruto | null;
  modo: Modo;
  slug: string;
  aoLimparFiltros: () => void;
  aoVerCodigo: () => void;
}

export function VazioDoGrafo({ grafo, codigo, modo, slug, aoLimparFiltros, aoVerCodigo }: Props) {
  const total = (grafo?.nodes || []).length;

  if (total) {
    return (
      <div className="g-empty show">
        <div>
          <b>Os filtros escondem tudo.</b><br />
          <span className="muted">
            {total} nó(s) existem neste projeto, mas nenhum passa pela combinação atual de tipo,
            relação e profundidade.
          </span>
          <div style={{ marginTop: 10 }}>
            <button className="btn sm" type="button" onClick={aoLimparFiltros}>Limpar filtros</button>
          </div>
        </div>
      </div>
    );
  }

  if (modo === 'memoria') {
    const nosDoCodigo = (codigo?.nodes || []).length;
    return (
      <div className="g-empty show">
        <div>
          <b>Ninguém escreveu memória neste projeto ainda.</b>
          <br />
          <span className="muted">
            Este grafo mostra o que o <b>time</b> escreveu — nota, decisão, runbook, sessão e lacuna —
            e as ligações disso com os arquivos. Não vem do código: reprocessar o acervo não cria
            nenhum nó aqui.
            {nosDoCodigo ? ` O grafo de código segue inteiro, com ${nosDoCodigo} nó(s).` : ''}
          </span>
          {!!nosDoCodigo && (
            <div style={{ marginTop: 12, display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button className="btn sm" type="button" onClick={aoVerCodigo}>Ver o grafo de código</button>
            </div>
          )}
          <div className="muted" style={{ marginTop: 12, fontSize: 12, lineHeight: 1.9 }}>
            A memória nasce de três lugares:<br />
            no painel, pelo <b>+</b> ao lado de qualquer bloco da doc<br />
            <code className="kbd">eng note &lt;arquivo&gt; &quot;o que o código não mostra&quot;</code><br />
            <code className="kbd">eng session start &quot;tarefa&quot;</code> e depois{' '}
            <code className="kbd">eng session close &quot;resumo&quot;</code>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="g-empty show">
      <div>
        <b>Este projeto ainda não tem grafo.</b><br />
        <span className="muted">
          O grafo vem do AST, extraído no ingest. Enquanto o CI não rodar uma vez, não há nó para
          desenhar.
        </span>
        <div style={{ marginTop: 10 }}>
          <code className="kbd">eng reprocess {slug || '<projeto>'}</code>
        </div>
      </div>
    </div>
  );
}
